// mapping is taken from previous form

const AgeGroup = {
  Neonate: { value: 'Neonate', e2b: '1' },
  Infant: { value: 'Infant', e2b: '2' },
  Child: { value: 'Child', e2b: '3' },
  Adolescent: { value: 'Adolescent', e2b: '4' },
  Adult: { value: 'Adult', e2b: '5' },
  Elderly: { value: 'Elderly', e2b: '6' },
  Foetus: { value: 'Foetus', e2b: '7' },
};

export const YearsConst = 'Years';

export const ageUnits = [
  { value: 'Minutes', e2b: '806', multiplier: 60 },
  { value: 'Seconds', e2b: '807', multiplier: 1 },
  { value: 'Trimester', e2b: '810', multiplier: 7776000 },
  { value: 'Hours', e2b: '805', multiplier: 3600 },
  { value: 'Days', e2b: '804', multiplier: 86400 },
  { value: 'Months', e2b: '802', multiplier: 2592000 },
  { value: YearsConst, e2b: '801', multiplier: 31536000 },
  { value: 'Decades', e2b: '800', multiplier: 315360000 },
  { value: 'Weeks', e2b: '803', multiplier: 604800 },
];

const ageValidation = [
  {
    key: AgeGroup.Adolescent,
    min: 378432000,
    max: 567648000,
  },
  {
    key: AgeGroup.Adult,
    min: 567648000,
    max: 2049840000,
  },
  {
    key: AgeGroup.Child,
    min: 63072000,
    max: 378432000,
  },
  {
    key: AgeGroup.Elderly,
    min: 2049840000,
    max: 4730400001,
  },
  {
    key: AgeGroup.Foetus,
    min: 0,
    max: 1,
  },
  {
    key: AgeGroup.Infant,
    min: 2396736,
    max: 63072000,
  },
  {
    key: AgeGroup.Neonate,
    min: 1,
    max: 2396736,
  },
];

export const convertToSeconds = (age: number, unit: string) => {
  return ageUnits.find(({ value, e2b }) => [e2b, value].includes(unit))?.multiplier * age;
};

export const getAgeGroup = (age: number | string, e2bUnit: string) => {
  const ageGroup = ageValidation.find(({ min, max }) => {
    const seconds = convertToSeconds(+age, e2bUnit);
    return seconds >= min && seconds < max;
  });

  return ageGroup?.key ?? AgeGroup.Elderly;
};
